import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DEFAULT_RECOMMENDATION_LIMIT } from "../../constants";
import { HydratedRecommendation } from "../../recommendation.types";
import { requestGetProductRecommendations } from "./getProductRecommendations.request";

const useProductRecommendations = (
  id: string,
  limit: number = DEFAULT_RECOMMENDATION_LIMIT,
  options?: QueryOptions<HydratedRecommendation[], ApiServiceError<ApiError>>
) => {
  const { data: recommendations, ...rest } = useQuery({
    queryKey: ["recommendation", "product", id, limit],
    queryFn: async () =>
      await requestGetProductRecommendations(id, { limit }),
    onError: toastServerError,
    enabled: Boolean(id),
    ...options
  });

  return { recommendations: recommendations ?? [], ...rest };
};

export default useProductRecommendations;
